import { PayloadAction, createSlice } from "@reduxjs/toolkit";

export const Donation = "donation";
export type Donation = typeof Donation;

export interface DonorInfo {
    name: string,
    email: string,
    mobileNumber: string
}

export type DonationInfo = {
    donationAmount: number | null,
    name?: string,
    email?: string,
    mobileNumber?: string
}

export interface DonationState {
    data: DonationInfo,
}

const initialState: DonationState = {
    data: {
        donationAmount: 0
    },
}

const donationSlice = createSlice({
    name: Donation,
    initialState,
    reducers: {
        setDonationAmount: (state: DonationState, action: PayloadAction<number>) => {
            state.data.donationAmount = action.payload;
        },
        setDonorInfo: (state: DonationState, action: PayloadAction<DonorInfo>) => {
            state.data.email = action.payload.email;
            state.data.mobileNumber = action.payload.mobileNumber;
            state.data.name = action.payload.name;
        },
        resetDonorInfo: (state: DonationState) => { 
            state.data.email = undefined;
            state.data.mobileNumber = undefined;
            state.data.name = undefined;
        },
        clearDonationAmount: (state: DonationState) => {
            state.data.donationAmount = null;
        }
    }
});

export default donationSlice.reducer;
export const { setDonationAmount, clearDonationAmount, setDonorInfo, resetDonorInfo } = donationSlice.actions;